import { CatalogPermission } from '../Interfaces/catalog-permission.interface';

export class User {
  id!: number;
  first_name!: string | null;
  last_name!: string | null;
  email!: string;
  displayName!: string | null;
  userPrincipalName!: string | null;
  photo!: string | null;
  preferred_lang!: string | null;
  preferred_theme!: string | null;
  catalog_permissions!: CatalogPermission[];

  constructor(data: Partial<User>) {
    Object.assign(this, data);
  }

  getDisplayName(): string {
    const full = `${this.first_name ?? ''} ${this.last_name ?? ''}`.trim();
    return full || this.displayName || this.email;
  }
}
